module.exports = __webpack_public_path__ + "static/media/close_mw.14941329.svg";